import {FilesAccordionState} from "../types/multi-type-files-viewer.types";

export const multiTypeFilesViewerModalName = 'multi-type-files-viewer';

export const defaultFilesAccordionState: FilesAccordionState = {
  isOpen: false,
  key: ''
}
